import List, { PROPERTY_PLAN } from "./list";

function ReviewPlanAssignments() {
  return <List type={PROPERTY_PLAN} isOrphanedView />;
}

export default ReviewPlanAssignments;
